<div [ngSwitch]="mobileMessageType">
	<div *ngSwitchCase="MESSAGE_TYPE.SUCCESS" class="mobile-message success-message">
		<nz-layout>
			<nz-header>
			</nz-header>
			<nz-content>
				<div class="vertically-centralized">
					<div class="text-center msg-icon flex justify-center">
						<svg fill="none" height="113" viewBox="0 0 140 113" width="140"
							xmlns="http://www.w3.org/2000/svg">
							<ellipse cx="67.7532" cy="55.3756" fill="url(#paint0_linear_4542_210160)" rx="55.6536"
								ry="55.376" />
							<g filter="url(#filter0_d_4542_210160)">
								<path clip-rule="evenodd"
									d="M59.4065 64.6105L44.553 50.2382L37.2988 57.4562L55.2029 75.271C55.3127 75.4051 55.4304 75.5349 55.556 75.6598C55.6816 75.7848 55.812 75.9019 55.9468 76.0112L56.6434 76.7043L56.778 76.5604C58.7167 77.585 61.1771 77.2848 62.8102 75.6598L98.202 40.4446L94.8805 37.1397C92.7085 34.9785 89.187 34.9785 87.015 37.1397L59.4065 64.6105Z"
									fill="white" fill-rule="evenodd" />
							</g>
							<path
								d="M126.639 16.2722L130.781 14.8455C131.081 14.746 131.081 14.2483 130.781 14.1488L126.639 12.7222C126.533 12.689 126.455 12.6005 126.426 12.4789L125.178 7.75664C125.091 7.4138 124.655 7.4138 124.568 7.75664L123.32 12.4789C123.291 12.6005 123.213 12.689 123.107 12.7222L118.975 14.1488C118.675 14.2483 118.675 14.746 118.975 14.8455L123.117 16.2722C123.223 16.3053 123.3 16.3938 123.33 16.5155L124.578 21.2488C124.665 21.5916 125.1 21.5916 125.187 21.2488L126.436 16.5155C126.455 16.3938 126.533 16.3053 126.639 16.2722Z"
								fill="#ECAB03" />
							<path
								d="M5.77681 32.6732L8.80959 31.6285C9.02925 31.5556 9.02925 31.1912 8.80959 31.1183L5.77681 30.0736C5.69886 30.0494 5.64218 29.9846 5.62092 29.8955L4.70683 26.4376C4.64306 26.1865 4.32419 26.1865 4.26042 26.4376L3.34633 29.8955C3.32507 29.9846 3.26839 30.0494 3.19044 30.0736L0.164748 31.1183C-0.054916 31.1912 -0.054916 31.5556 0.164748 31.6285L3.19753 32.6732C3.27547 32.6975 3.33216 32.7623 3.35342 32.8513L4.2675 36.3174C4.33128 36.5684 4.65015 36.5684 4.71392 36.3174L5.628 32.8513C5.64218 32.7623 5.69886 32.6975 5.77681 32.6732Z"
								fill="#ECAB03" />
							<path
								d="M19.4552 105.654L25.0753 103.718C25.4824 103.583 25.4824 102.908 25.0753 102.772L19.4552 100.837C19.3107 100.792 19.2057 100.671 19.1663 100.506L17.4724 94.0984C17.3542 93.6332 16.7633 93.6332 16.6451 94.0984L14.9512 100.506C14.9118 100.671 14.8067 100.792 14.6623 100.837L9.0553 102.772C8.64823 102.908 8.64823 103.583 9.0553 103.718L14.6754 105.654C14.8199 105.699 14.9249 105.819 14.9643 105.984L16.6582 112.407C16.7764 112.872 17.3673 112.872 17.4855 112.407L19.1794 105.984C19.2057 105.819 19.3107 105.699 19.4552 105.654Z"
								fill="#ECAB03" />
							<defs>
								<filter color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="51.5249"
									id="filter0_d_4542_210160" width="70.7922" x="32.3544" y="35.5188">
									<feFlood flood-opacity="0" result="BackgroundImageFix" />
									<feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix"
										values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
									<feOffset dy="4.94444" />
									<feGaussianBlur stdDeviation="2.47222" />
									<feComposite in2="hardAlpha" operator="out" />
									<feColorMatrix type="matrix"
										values="0 0 0 0 0.0868924 0 0 0 0 0.595833 0 0 0 0 0.348739 0 0 0 1 0" />
									<feBlend in2="BackgroundImageFix" mode="normal"
										result="effect1_dropShadow_4542_210160" />
									<feBlend in="SourceGraphic" in2="effect1_dropShadow_4542_210160" mode="normal"
										result="shape" />
								</filter>
								<linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_4542_210160"
									x1="67.7532" x2="67.753" y1="-28.796" y2="89.7087">
									<stop stop-color="#D0DB51" />
									<stop offset="1" stop-color="#17A25F" />
								</linearGradient>
							</defs>
						</svg>
					</div>
					<div class="title">
						{{title}}
					</div>
					<div class="message">
						{{description}}
					</div>

					<div *ngIf="extraMessage" class="extra-info mt-[31px]">
						<div class="extra-message">
							<div class="detail">
								<svg fill="none" height="24" viewBox="0 0 24 24" width="24"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM9.99 10.99V13H10.99V17H14.01V15H13L13.01 10.991L9.99 10.99ZM10.99 7V9.019H13.01V7H10.99Z"
										fill="#0361F0" />
								</svg>
								<p>{{extraMessage}}</p>
							</div>
						</div>
					</div>
				</div>
			</nz-content>
			<nz-footer>
				<div (click)="continue()" class="close-btn">
					<span *ngIf="!loading else loadingTemplate">{{buttonName}}</span>
					<ng-template #loadingTemplate>
						<span style="padding-top:1px">
							<i [nzType]="'loading'" nz-icon></i>
						</span>
					</ng-template>
				</div>
			</nz-footer>
		</nz-layout>
	</div>
	<div *ngSwitchCase="MESSAGE_TYPE.PENDING" class="mobile-message pending-message">
		<nz-layout>
			<nz-header>
			</nz-header>
			<nz-content>
				<div class="vertically-centralized">
					<div class="text-center msg-icon flex justify-center">
						<svg fill="none" height="112" viewBox="0 0 140 112" width="140"
							xmlns="http://www.w3.org/2000/svg">
							<ellipse cx="67.7527" cy="55.376" fill="url(#paint0_linear_10010_115596)" rx="55.6536"
								ry="55.376" />
							<g filter="url(#filter0_d_10010_115596)">
								<path clip-rule="evenodd"
									d="M70.6471 48.0551V43.6691C63.1886 43.658 56.528 48.7004 55.1214 55.9149C53.7296 63.0432 57.8844 70.077 65.0001 72.6413C67.0361 73.3756 68.0585 75.5338 67.2873 77.4695C66.6017 79.1883 64.7253 80.1479 62.8902 79.8253C62.6597 79.7863 62.4292 79.7251 62.2046 79.6445C51.5222 75.8008 45.2841 65.246 47.3733 54.5549C49.4832 43.7387 59.4683 36.2043 70.6471 36.2182V32.5831C70.6471 30.8393 72.9787 29.9409 74.3912 31.1452L83.4749 38.8798C84.394 39.6641 84.394 40.9769 83.4749 41.7612L74.3912 49.4958C72.9787 50.6973 70.6471 49.8018 70.6471 48.0551ZM75.8569 72.7609C75.2718 72.9611 74.6689 73.128 74.0602 73.256C71.9355 73.7037 70.591 75.7035 71.0609 77.7226C71.4125 79.2356 72.6832 80.3287 74.1902 80.5957C74.6955 80.6819 75.2274 80.6791 75.7594 80.5678C76.6872 80.3704 77.6003 80.1201 78.4928 79.8197C80.5406 79.1272 81.6162 76.9828 80.8893 75.036C80.1594 73.0863 77.9018 72.0684 75.8569 72.7609ZM83.6907 67.001C83.5222 67.2401 83.3479 67.4738 83.1617 67.7018C81.8349 69.34 82.154 71.6901 83.8798 72.9528C84.394 73.3255 84.9672 73.5619 85.5642 73.6648C86.9707 73.9123 88.4719 73.4201 89.4086 72.2658C89.6894 71.9154 89.9642 71.5538 90.2272 71.1839C91.4417 69.4679 90.966 67.1428 89.1634 65.9858C87.3579 64.8371 84.9081 65.2849 83.6907 67.001ZM90.4163 55.5144C88.2414 55.4588 86.427 57.1637 86.3709 59.2329C86.3177 61.0936 87.7066 62.6455 89.5741 62.9737C89.7751 63.0099 89.9849 63.0321 90.1947 63.0349C92.3666 63.0961 94.181 61.4357 94.249 59.3692C94.249 59.3637 94.2519 59.2886 94.2519 59.283C94.311 57.2138 92.5764 55.5506 90.4163 55.5144Z"
									fill="white" fill-rule="evenodd" />
							</g>
							<defs>
								<filter color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="76.6389"
									id="filter0_d_10010_115596" width="76.6389" x="30.9027" y="22.25">
									<feFlood flood-opacity="0" result="BackgroundImageFix" />
									<feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix"
										values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
									<feOffset dy="4.94444" />
									<feGaussianBlur stdDeviation="2.47222" />
									<feComposite in2="hardAlpha" operator="out" />
									<feColorMatrix type="matrix"
										values="0 0 0 0 0.895833 0 0 0 0 0.686997 0 0 0 0 0.041059 0 0 0 1 0" />
									<feBlend in2="BackgroundImageFix" mode="normal"
										result="effect1_dropShadow_10010_115596" />
									<feBlend in="SourceGraphic" in2="effect1_dropShadow_10010_115596" mode="normal"
										result="shape" />
								</filter>
								<linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_10010_115596"
									x1="67.7527" x2="67.7527" y1="0" y2="110.752">
									<stop stop-color="#F4C563" />
									<stop offset="1" stop-color="#CE8B00" />
								</linearGradient>
							</defs>
						</svg>
					</div>
					<div class="title">
						{{title}}
					</div>
					<div class="message">
						{{description}}
					</div>

					<div *ngIf="extraMessage" class="extra-info m-t-31">
						<div class="extra-message">
							<div class="detail">
								<svg fill="none" height="24" viewBox="0 0 24 24" width="24"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM9.99 10.99V13H10.99V17H14.01V15H13L13.01 10.991L9.99 10.99ZM10.99 7V9.019H13.01V7H10.99Z"
										fill="#0361F0" />
								</svg>
								<p>{{extraMessage}}</p>
							</div>
						</div>
					</div>
				</div>
			</nz-content>
			<nz-footer>
				<div (click)="continue()" class="close-btn">
					<span *ngIf="!loading else loadingTemplate">{{buttonName}}</span>
					<ng-template #loadingTemplate>
						<span style="padding-top:1px">
							<i [nzType]="'loading'" nz-icon></i>
						</span>
					</ng-template>
				</div>
			</nz-footer>
		</nz-layout>
	</div>
	<div *ngSwitchCase="MESSAGE_TYPE.FAILURE" class="mobile-message error-message">
		<nz-layout>
			<nz-header>
			</nz-header>
			<nz-content>
				<div class="vertically-centralized">
					<div class="flex justify-center msg-icon">
						<svg fill="none" height="113" viewBox="0 0 142 113" width="142"
							xmlns="http://www.w3.org/2000/svg">
							<ellipse cx="68.7523" cy="55.38" fill="url(#paint0_linear_4563_212671)" rx="55.6576"
								ry="55.38" />
							<g filter="url(#filter0_d_4563_212671)">
								<path clip-rule="evenodd"
									d="M49.2877 37.0852C47.4804 39.1325 47.6749 42.2574 49.7222 44.0647L62.6958 55.5179L47.9702 72.1984L51.6772 75.4709C53.7245 77.2783 56.8493 77.0838 58.6567 75.0365L70.1097 62.0629L86.7919 76.79L90.0644 73.083C91.8718 71.0357 91.6773 67.9109 89.63 66.1035L76.6548 54.649L91.3819 37.9668L87.675 34.6942C85.6277 32.8869 82.5028 33.0814 80.6955 35.1287L69.2409 48.1039L52.5602 33.3783L49.2877 37.0852Z"
									fill="white" fill-rule="evenodd" />
							</g>
							<defs>
								<filter color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="53.3013"
									id="filter0_d_4563_212671" width="53.3012" x="43.0254" y="33.3783">
									<feFlood flood-opacity="0" result="BackgroundImageFix" />
									<feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix"
										values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
									<feOffset dy="4.9448" />
									<feGaussianBlur stdDeviation="2.4724" />
									<feComposite in2="hardAlpha" operator="out" />
									<feColorMatrix type="matrix"
										values="0 0 0 0 0.85 0 0 0 0 0.223125 0 0 0 0 0.223125 0 0 0 1 0" />
									<feBlend in2="BackgroundImageFix" mode="normal"
										result="effect1_dropShadow_4563_212671" />
									<feBlend in="SourceGraphic" in2="effect1_dropShadow_4563_212671" mode="normal"
										result="shape" />
								</filter>
								<linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_4563_212671"
									x1="98.6543" x2="24.4823" y1="111.258" y2="-26.5783">
									<stop stop-color="#E94444" />
									<stop offset="1" stop-color="#F98484" />
								</linearGradient>
							</defs>
						</svg>
					</div>
					<div class="title">
						{{title}}
					</div>
					<div class="message">
						{{description}}
					</div>
				</div>
			</nz-content>
			<nz-footer>
				<div *ngIf="!useFailureSecondaryButton" (click)="emitAction.emit(CANCEL)" class="close-btn">
					{{buttonName}}
				</div>
				<div *ngIf="useFailureSecondaryButton">
					<button
						class="w-[100%] h-[56px] rounded-[8px] p-[7px_16px_7px_16px] font-[500] text-[14px] leading-[17.36px] text-[#fff] text-center bg-[rgba(255,255,255,0.1)]"
						(click)="emitSecondaryAction.emit(CANCEL)">
						{{secondaryButtonName}}
					</button>
					<button
						class="w-[100%] h-[56px] rounded-[8px] p-[7px_16px_7px_16px] font-[500] text-[14px] leading-[17.36px] text-[#fff] text-center"
						(click)="emitAction.emit(CANCEL)">
						{{buttonName}}
					</button>
				</div>
			</nz-footer>
		</nz-layout>
	</div>
	<div *ngSwitchCase="MESSAGE_TYPE.SUSPENDED_OTP">
		<div class="mobile-message otp-validation-error">
			<nz-layout>
				<nz-header>
				</nz-header>
				<nz-content>
					<div class="vertically-centralized">
						<div class="flex justify-center msg-otp-icon">
							<svg fill="none" height="113" viewBox="0 0 142 113" width="142"
								xmlns="http://www.w3.org/2000/svg">
								<ellipse cx="68.7523" cy="55.38" fill="url(#paint0_linear_4563_212671)" rx="55.6576"
									ry="55.38" />
								<g filter="url(#filter0_d_4563_212671)">
									<path clip-rule="evenodd"
										d="M49.2877 37.0852C47.4804 39.1325 47.6749 42.2574 49.7222 44.0647L62.6958 55.5179L47.9702 72.1984L51.6772 75.4709C53.7245 77.2783 56.8493 77.0838 58.6567 75.0365L70.1097 62.0629L86.7919 76.79L90.0644 73.083C91.8718 71.0357 91.6773 67.9109 89.63 66.1035L76.6548 54.649L91.3819 37.9668L87.675 34.6942C85.6277 32.8869 82.5028 33.0814 80.6955 35.1287L69.2409 48.1039L52.5602 33.3783L49.2877 37.0852Z"
										fill="white" fill-rule="evenodd" />
								</g>
								<defs>
									<filter color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"
										height="53.3013" id="filter0_d_4563_212671" width="53.3012" x="43.0254"
										y="33.3783">
										<feFlood flood-opacity="0" result="BackgroundImageFix" />
										<feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix"
											values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
										<feOffset dy="4.9448" />
										<feGaussianBlur stdDeviation="2.4724" />
										<feComposite in2="hardAlpha" operator="out" />
										<feColorMatrix type="matrix"
											values="0 0 0 0 0.85 0 0 0 0 0.223125 0 0 0 0 0.223125 0 0 0 1 0" />
										<feBlend in2="BackgroundImageFix" mode="normal"
											result="effect1_dropShadow_4563_212671" />
										<feBlend in="SourceGraphic" in2="effect1_dropShadow_4563_212671" mode="normal"
											result="shape" />
									</filter>
									<linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_4563_212671"
										x1="98.6543" x2="24.4823" y1="111.258" y2="-26.5783">
										<stop stop-color="#E94444" />
										<stop offset="1" stop-color="#F98484" />
									</linearGradient>
								</defs>
							</svg>
						</div>
						<div class="title otp-title">
							{{title}}
						</div>
						<div class="message">
							{{description}}
						</div>
						<div class="m-t-31">
							<app-otp-count-down (emitFinishSuspension)="enableRetryButton($event)"
								[countdownType]="countdownType" [expiryTime]="otpSuspensionExpiryTime">
							</app-otp-count-down>
						</div>
					</div>
				</nz-content>
				<nz-footer>
					<div (click)="retryOTP()" class="close-btn">
						{{buttonName}}
					</div>
				</nz-footer>
			</nz-layout>
		</div>
	</div>
	<div *ngSwitchCase="MESSAGE_TYPE.IN_REVIEW" class="mobile-message error-message">
		<nz-layout>
			<nz-header>
			</nz-header>
			<nz-content>
				<div class="vertically-centralized">
					<div class="flex justify-center msg-icon">
						<svg fill="none" height="74" viewBox="0 0 73 74" width="73" xmlns="http://www.w3.org/2000/svg">
							<circle cx="36.5" cy="37" fill="#F08922" fill-opacity="0.2" r="36.5" />
							<path
								d="M37 59.5C24.5736 59.5 14.5 49.4264 14.5 37C14.5 24.5736 24.5736 14.5 37 14.5C49.4264 14.5 59.5 24.5736 59.5 37C59.4864 49.4208 49.4208 59.4864 37 59.5ZM34.75 43.75V48.25H39.25V43.75H34.75ZM34.75 25.75V39.25H39.25V25.75H34.75Z"
								fill="#F08922" />
						</svg>

					</div>
					<div class="title">
						{{title}}
					</div>
					<div class="message">
						{{description}}
					</div>
				</div>
			</nz-content>
			<nz-footer>
				<div (click)="emitAction.emit(CANCEL)" class="close-btn">
					{{buttonName}}
				</div>
			</nz-footer>
		</nz-layout>
	</div>
	<div *ngSwitchCase="MESSAGE_TYPE.IN_PROGRESS" class="mobile-message success-message">
		<nz-layout>
			<nz-header>
			</nz-header>
			<nz-content>
				<div class="vertically-centralized">
					<div class="flex justify-center msg-icon">
						<svg fill="none" height="113" viewBox="0 0 140 113" width="140"
							xmlns="http://www.w3.org/2000/svg">
							<ellipse cx="67.7532" cy="55.3756" fill="url(#paint0_linear_4542_210160)" rx="55.6536"
								ry="55.376" />
							<g filter="url(#filter0_d_4542_210160)">
								<path clip-rule="evenodd"
									d="M59.4065 64.6105L44.553 50.2382L37.2988 57.4562L55.2029 75.271C55.3127 75.4051 55.4304 75.5349 55.556 75.6598C55.6816 75.7848 55.812 75.9019 55.9468 76.0112L56.6434 76.7043L56.778 76.5604C58.7167 77.585 61.1771 77.2848 62.8102 75.6598L98.202 40.4446L94.8805 37.1397C92.7085 34.9785 89.187 34.9785 87.015 37.1397L59.4065 64.6105Z"
									fill="white" fill-rule="evenodd" />
							</g>
							<path
								d="M126.639 16.2722L130.781 14.8455C131.081 14.746 131.081 14.2483 130.781 14.1488L126.639 12.7222C126.533 12.689 126.455 12.6005 126.426 12.4789L125.178 7.75664C125.091 7.4138 124.655 7.4138 124.568 7.75664L123.32 12.4789C123.291 12.6005 123.213 12.689 123.107 12.7222L118.975 14.1488C118.675 14.2483 118.675 14.746 118.975 14.8455L123.117 16.2722C123.223 16.3053 123.3 16.3938 123.33 16.5155L124.578 21.2488C124.665 21.5916 125.1 21.5916 125.187 21.2488L126.436 16.5155C126.455 16.3938 126.533 16.3053 126.639 16.2722Z"
								fill="#ECAB03" />
							<path
								d="M5.77681 32.6732L8.80959 31.6285C9.02925 31.5556 9.02925 31.1912 8.80959 31.1183L5.77681 30.0736C5.69886 30.0494 5.64218 29.9846 5.62092 29.8955L4.70683 26.4376C4.64306 26.1865 4.32419 26.1865 4.26042 26.4376L3.34633 29.8955C3.32507 29.9846 3.26839 30.0494 3.19044 30.0736L0.164748 31.1183C-0.054916 31.1912 -0.054916 31.5556 0.164748 31.6285L3.19753 32.6732C3.27547 32.6975 3.33216 32.7623 3.35342 32.8513L4.2675 36.3174C4.33128 36.5684 4.65015 36.5684 4.71392 36.3174L5.628 32.8513C5.64218 32.7623 5.69886 32.6975 5.77681 32.6732Z"
								fill="#ECAB03" />
							<path
								d="M19.4552 105.654L25.0753 103.718C25.4824 103.583 25.4824 102.908 25.0753 102.772L19.4552 100.837C19.3107 100.792 19.2057 100.671 19.1663 100.506L17.4724 94.0984C17.3542 93.6332 16.7633 93.6332 16.6451 94.0984L14.9512 100.506C14.9118 100.671 14.8067 100.792 14.6623 100.837L9.0553 102.772C8.64823 102.908 8.64823 103.583 9.0553 103.718L14.6754 105.654C14.8199 105.699 14.9249 105.819 14.9643 105.984L16.6582 112.407C16.7764 112.872 17.3673 112.872 17.4855 112.407L19.1794 105.984C19.2057 105.819 19.3107 105.699 19.4552 105.654Z"
								fill="#ECAB03" />
							<defs>
								<filter color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="51.5249"
									id="filter0_d_4542_210160" width="70.7922" x="32.3544" y="35.5188">
									<feFlood flood-opacity="0" result="BackgroundImageFix" />
									<feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix"
										values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
									<feOffset dy="4.94444" />
									<feGaussianBlur stdDeviation="2.47222" />
									<feComposite in2="hardAlpha" operator="out" />
									<feColorMatrix type="matrix"
										values="0 0 0 0 0.0868924 0 0 0 0 0.595833 0 0 0 0 0.348739 0 0 0 1 0" />
									<feBlend in2="BackgroundImageFix" mode="normal"
										result="effect1_dropShadow_4542_210160" />
									<feBlend in="SourceGraphic" in2="effect1_dropShadow_4542_210160" mode="normal"
										result="shape" />
								</filter>
								<linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_4542_210160"
									x1="67.7532" x2="67.753" y1="-28.796" y2="89.7087">
									<stop stop-color="#D0DB51" />
									<stop offset="1" stop-color="#17A25F" />
								</linearGradient>
							</defs>
						</svg>
					</div>
					<div class="title">
						{{title}}
					</div>
					<div class="message">
						{{description}}
					</div>
				</div>
			</nz-content>
			<nz-footer>
				<div (click)="emitAction.emit(CANCEL)" class="close-btn">
					{{buttonName}}
				</div>
			</nz-footer>
		</nz-layout>
	</div>
</div>